import React from "react";
import { IoCloseCircleSharp } from "react-icons/io5";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";

const Rejected = () => {
    const navigate = useNavigate();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-red-50">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-md justify-center w-full text-center">
        <IoCloseCircleSharp className="text-red-600 text-6xl mx-auto mb-4" />
        <h2 className="text-2xl font-semibold text-red-600 mb-2"><FormattedMessage id="subscription_failed" defaultMessage={"Subscription Failed!"} /></h2>
        <p className="text-lg text-t-light mb-6"><FormattedMessage id="subscription_failed_desc" defaultMessage={"There was an issue with your payment. Please try again"} />.</p>
        <button
          onClick={() => navigate("/")}
          className="bg-red-600 text-white py-2 px-4 rounded-md text-lg hover:-translate-y-1 transition-all duration-300"
        >
          <FormattedMessage id="back_to_home" defaultMessage={"Back to Home"} />
        </button>
      </div>
    </div>
  );
};

export default Rejected;
